import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FiscalConfigModel } from 'src/app/ceq/common/models/FiscalConfig.Model';
import { SettingsService } from 'src/app/core/settings/settings.service';
import { FiscalconfigService } from '../fiscalconfig.service';
import { toNumber } from 'lodash';
import { UserLogin } from 'src/app/ceq/common/models/UserLogin.Model';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';

@Component({
  selector: 'app-fiscalconfig-detail',
  templateUrl: './fiscalconfig-detail.component.html',
  styleUrls: ['./fiscalconfig-detail.component.scss']
})
export class FiscalconfigDetailComponent implements OnInit {

  userLogin: UserLogin;
  fiscalconfig: FiscalConfigModel = new FiscalConfigModel();
  isNew: boolean = false;

  constructor(
    private url: ActivatedRoute,
    private router: Router,
    private settings: SettingsService,
    private globalFunctionService: GlobalFunctionsService,
    private fiscalConfigService: FiscalconfigService
  ) { }

  ngOnInit(): void {
    this.userLogin = this.settings.getUser();
    const currentId = this.url.snapshot.paramMap.get('id');

    // Inicialización básica
    this.fiscalconfig.Org = this.userLogin.Org;

    if (this.isNullOrWhitespace(currentId) || currentId === 'create') {
      this.fiscalconfig.IdFiscalConfig = 0;
      this.isNew = true;
    } else {
      this.fiscalconfig.IdFiscalConfig = toNumber(currentId);
      this.isNew = false;
      this.getFiscalConfig();
    }
  }

  getFiscalConfig() {
    this.fiscalConfigService.getFiscalConfigById(this.fiscalconfig.IdFiscalConfig).subscribe({
      next: (data) => {
        if (data) {
          this.fiscalconfig = data;
        }
      },
      error: async () => {
        await this.globalFunctionService.messageBimbo("No se encontró la configuración solicitada", 'error', '¡Error!');
        this.btnCancelOnClick();
      }
    });
  }

  formSubmit() {
    const operation = this.isNew 
      ? this.fiscalConfigService.createFiscalConfig(this.fiscalconfig)
      : this.fiscalConfigService.updateFiscalConfig(this.fiscalconfig);

    operation.subscribe({
      next: async () => {
        const message = this.isNew ? 'Configuración creada' : 'Configuración actualizada';
        await this.globalFunctionService.messageBimbo(message, 'success', '¡Éxito!');
        this.btnCancelOnClick();
      },
      error: async (err) => {
        const errorMsg = err.error || 'Ocurrió un error al procesar la solicitud';
        await this.globalFunctionService.messageBimbo(errorMsg, 'error', '¡Error!');
      }
    });
  }

  btnCancelOnClick() {
    this.router.navigate(['/tax/fiscalconfig']);
  }

  private isNullOrWhitespace(input: any): boolean {
    return !input || input.toString().trim().length < 1;
  }
}